import { MultilineInput } from '@amelio/ui-library';

export interface OptionTranslationInputProps {
    optionId: string;
    targetValue: string;
    placeholder: string;
    onChange: (value: string) => void;
    className?: string;
}

export const OptionTranslationInput = ({
    optionId,
    targetValue,
    placeholder,
    onChange,
    className,
}: OptionTranslationInputProps) => (
    <MultilineInput
        value={targetValue}
        onChange={onChange}
        placeholder={placeholder}
        rows={1}
        autoGrow={true}
        variant={'white'}
        className={['px-3 py-2', className].filter(Boolean).join(' ')}
        dataTestId={`option-translation-input-${optionId}`}
    />
);
